// AI Generated Component
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-missing-title',
    standalone: false,
    template: `
        <h5 translate>No title is found on this page</h5>
    `,
})
export class SeoInformationMissingTitleComponent {
    @Input() seo: any;
}
